module.exports = __webpack_public_path__ + "static/ASHA-CCC-Color-4ce989d7def6b8658d2a926965b76988.png";